export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    width: 60,
    align: 'center',
    slots: {
      default: 'opt1',
    },
    titleHelp: { message: '按住后可以上下拖动排序！' },
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',

    width: 110,
    fixed: 'left',
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'contactName',
    title: '联系人姓名',
    headerAlign: 'center',
    minWidth: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'contactMobile',
    title: '联系人手机',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'contactPhone',
    title: '固定电话',
    headerAlign: 'center',
    minWidth: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },

  {
    field: 'contactEmail',
    title: '联系人Email',
    headerAlign: 'center',
    minWidth: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'contactJob',
    title: '联系人职务',
    headerAlign: 'center',
    minWidth: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'v_allowLogin',
    title: '是否允许登录系统',
    align: 'center',
    minWidth: 100,
    slots: { default: 'allow' },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: '登录角色',
    field: 'v_loginRole',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'contactRemarks',
    title: '联系人备注',
    headerAlign: 'center',
    minWidth: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'contactStatusName',
    align: 'center',
    width: 80,
    title: '是否有效',
    slots: { default: 'status' },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createByName',
    title: '创建人',
    width: 80,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createTime',
    title: '创建时间',
    width: 160,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    field: 'modifyByName',
    title: '修改人',
    width: 80,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyTime',
    title: '修改时间',
    width: 160,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
]
